<template>
  <div>
    <div class="align-items-right">
      <p class="title text-right">
        <strong> {{ formatDocumentName() }} </strong>
      </p>
    </div>

    <article
      v-if="sia.complex_grade"
      class="tocitem"
      :title="$t('message.find_partner.common_info_Grade')"
    ></article>
    <table v-if="sia.complex_grade">
      <tr>
        <td>
          {{ $t("message.find_partner.common_info_Grade") }}
        </td>
        <td>
          {{ sia.complex_grade }} ({{
            sia.complex_grade < 50
              ? locale === "ru" ? "Плохо" : "Badly"
              : sia.complex_grade < 150
              ? locale === "ru" ? "Нормально": "Fine"
              : locale === "ru" ? "Хорошо" : "Good"
          }})
        </td>
      </tr>
      <tr>
        <td>
          {{ $t("message.find_partner.common_info_GradeDescription") }}
        </td>
        <td>
          <div v-html="sia.description"></div>
        </td>
      </tr>
      <tr>
        <td>
          {{ $t("message.find_partner.common_info_as_calculated_grade") }}
        </td>
        <td>
          <div v-html="sia.as_calculated_grade"></div>
        </td>
      </tr>
    </table>
    
    <search-help-text v-if="sia.complex_grade"></search-help-text>

    <article
      class="tocitem"
      v-if="goods.includes('430')"
      :title="$t('message.find_partner.common_info_cn')"
    ></article>
    <tmp-company-info-service-cn
      v-if="goods.includes('430')"
      :data="company_info_data"
      mode="pdf"
    ></tmp-company-info-service-cn>
    <article
      class="tocitem"
      v-if="goods.includes('930')"
      :title="$t('message.find_partner.court_notice_info')"
    ></article>
    <tmp-court-info-service-cn
      v-if="goods.includes('930')"
      :data="court_info_data"
    ></tmp-court-info-service-cn>
    <article
      class="tocitem"
      v-if="goods.includes('701')"
      :title="$t('message.find_partner.corporate_news_search')"
    ></article>
    <tmp-company-news-service-cn
      v-if="goods.includes('701')"
      :data="news_info_data"
      mode="pdf"
    ></tmp-company-news-service-cn>
    <article
      class="tocitem"
      v-if="goods.includes('736')"
      :title="$t('message.contragent_search.enterprise_risk_scan')"
    ></article>
    <tmp-risk-scan-cn
      v-if="goods.includes('736')"
      :data="risk_info_data"
      mode="pdf"
    ></tmp-risk-scan-cn>
    <enterprise-fuzzy-service-cn
      v-if="goods.includes('886')"
      :data="business_fuzzy_info"
      mode="pdf"
    ></enterprise-fuzzy-service-cn>
    <article
      class="tocitem"
      v-if="goods.includes('213')"
      :title="$t('message.contragent_search.annual_report')"
    ></article>
    <tmp-annual-report-service-cn
      v-if="goods.includes('213')"
      :data="annual_info_data"
      mode="pdf"
    ></tmp-annual-report-service-cn>

    <enterprise-fuzzy-service-cn-410
      mode="pdf"
      v-if="goods.includes('410')"
      :data="business_fuzzy_info"
      :progress="progress_fuzzy"
      :traffic_light="traffic_light"
    ></enterprise-fuzzy-service-cn-410>
  </div>
</template>
<script>
import moment from "moment";
export default {
  props: ["user_id", "doc_id", "doc", "goods", "doc_additional", "logo_required"],
  data() {
    return {
      company_info_data: {
        response_info: {},
        service_info: {},
        areaList: [],
        industryList: [],
        revokeInfoList: [],
        parentInfoList: [],

        UsedNameList: [],
        ShareHolderList: [],
        EmployeeList: [],
        InvestList: [],
        ChangeList: [],
        BranchList: [],
        MoreEmailList: [],
        EntTagList: [],
      },
      court_info_data: {
        response_info: {},
      },
      news_info_data: {
        response_info: {},
      },
      risk_info_data: {
        IndustryList: {},
        AreaList: {},
        RevokeInfoList: {},
        PenaltyList: [],
        ExceptionsList: [],
        ShiXinItemsList: [],
        ZhiXingItemsList: [],
        MPledgeList: [],
        PledgeList: [],
        SpotCheckList: [],
        CompanyTaxCreditItemsList: [],
        CompanyProductsList: [],
        PermissionEciInfoList: [],
        PenaltyCreditChinaList: [],
        PartnersList: [],
        EmployeesList: [],
        BranchesList: [],
        ChangeRecordsList: [],
        EmergingIndustyList: [],
        TagList: [],
        ARContactList: [],
        OriginalNameList: [],
      },
      annual_info_data: {},
      business_fuzzy_info: {
        response_info: {},
      },
      traffic_light: [],
      sia: {},
    };
  },
  mounted() {
    this.locale = this.$i18n.locale;
    if (this.doc.company_info_data)
      this.company_info_data = this.doc.company_info_data;
    if (this.doc.court_info_data)
      this.court_info_data = this.doc.court_info_data;
    if (this.doc.news_info_data) this.news_info_data = this.doc.news_info_data;
    if (this.doc.risk_info_data) this.risk_info_data = this.doc.risk_info_data;
    if (this.doc.annual_info_data)
      this.annual_info_data = this.doc.annual_info_data;
    if (this.doc.business_fuzzy_info)
      this.business_fuzzy_info = this.doc.business_fuzzy_info;
    if (this.doc.traffic_light) this.traffic_light = this.doc.traffic_light;
    if (this.doc.sia) this.sia = this.doc.sia;
    console.log("doc data");
    console.log(this.doc);
    setTimeout(() => {
      this.$root.$emit("print-pdf", { signature: "", type: "main-service-cn" });
    }, 1000);
  },
  computed: {},

  methods: {
    momentum(d) {
      return moment(d).format("D_MM_Y");
    },
    formatDocumentName() {
      var docName = "";
      if (this.doc_additional.searcher_full_name && this.logo_required)
        docName += this.doc_additional.searcher_full_name + " ";
      var servicesNames = this.goods
        .map((good) => {
          return this.$t("message.find_partner.service_" + good);
        })
        .join(",");
      docName += servicesNames;
      docName +=
        ", " + this.$t("message.find_partner.search_parameters") + ": ";
      if (this.doc_additional.keyWord)
        docName += this.doc_additional.keyWord + ", ";
      if (this.goods.includes("886"))
        docName +=
          this.doc_additional.keyWord886 +
          ", " +
          this.doc_additional.provinceCode +
          ", " +
          this.doc_additional.cityCode +
          ", ";

      docName += this.momentum(new Date());

      return docName;
    },
  },
};
</script>
